import { Inject, Injectable } from "@angular/core";
import { ConnectionStatus } from "../model/ConnectionStatus";
import { IConnectionStatusService, CHANNEL_CONNECTION_STATUS } from "../IConnectionStatusService";
import { Observable, ReplaySubject, Subscription } from "rxjs";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { CubiqBrokerClient } from "../../worker/CubiqBrokerClient";
import { CUBIQ_BROKER } from "../../worker/CubiqBrokerClient.constants";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class ConnectionStatusPrimaryService implements IConnectionStatusService {
  protected broker: ServiceMessageBroker;
  protected ports: Array<MessagePort> = new Array<MessagePort>();
  private currentConnectionStatus: number = 0;
  private sendLastStatus: boolean = false;
  private _connectionEventSubject: ReplaySubject<ConnectionStatus> =
    new ReplaySubject<ConnectionStatus>(1);

  private workerConnectionSubscription: Subscription;

  constructor(
    @Inject(CUBIQ_BROKER) private cubiqBroker: CubiqBrokerClient,
    protected factory: ServiceMessageBrokerFactory,
  ) {
    this.initialize();
  }

  protected initialize(): void {
    this.broker = this.factory.createMessageBroker(CHANNEL_CONNECTION_STATUS, true, true);
    this.broker.registerMethod("initPort", [PRIMITIVE], this.initPort.bind(this), null, false);
    this.broker.registerMethod(
      "isConnectionActive",
      [],
      this.isConnectionActive.bind(this),
      PRIMITIVE,
    );
    // this.broker.registerMethod('sendPing', [], this.sendPing.bind(this), null, false);

    this.workerConnectionSubscription = this.cubiqBroker.connectionEvent$.subscribe(
      (event: ConnectionStatus) => {
        this.currentConnectionStatus = event.getStatus();
        this._connectionEventSubject.next(event);
        if (this.ports && this.ports.length > 0) {
          this.sendMessageToAll(new ConnectionStatus(event.getStatus()));
        } else {
          this.sendLastStatus = true;
        }
      },
    );
  }

  public getConnectionEvents(): Observable<ConnectionStatus> {
    return this._connectionEventSubject;
  }

  public initPort(port: MessagePort): void {
    this.ports.push(port);
    if (this.sendLastStatus) {
      this.sendMessageToAll(new ConnectionStatus(this.currentConnectionStatus));
    }
  }

  public isConnectionActive(): Promise<ConnectionStatus> {
    return new Promise<ConnectionStatus>((res) => {
      res(new ConnectionStatus(this.currentConnectionStatus));
    });
  }

  private sendMessageToAll(message: any): void {
    this.ports.forEach((port) => {
      port.postMessage(message);
    });
  }

  // public sendPing():void{
  //     let ping = new CubiqTS.PingTimerImpl();
  //     ping.uiTxTime=new CubiqTS.Long(Date.now());
  //     this.worker.postServiceRequest(ping).then((response) => {
  //         // Nothing is returned, process it in the worker
  //         // let respPing = response as CubiqTS.PingTimerImpl;
  //         // if(respPing){
  //         //     let now = new CubiqTS.Long(Date.now());
  //         //     logger.out.info("Server Ping Dif:"+respPing.serverTxTime.subtract(respPing.serverRxTime).toString());
  //         //     logger.out.info("UI Ping Dif:"+now.subtract(respPing.uiTxTime).toString());
  //         //     logger.out.info("UI Start vs Server Start:"+respPing.serverRxTime.subtract(respPing.uiTxTime).toString());
  //         //     logger.out.info("Server End vs UI End:"+now.subtract(respPing.serverRxTime).toString());
  //         // }
  //     });
  // }
}
